export const USER_CURRENT_FETCH = 'USER/CURRENT/FETCH';
export const USER_CURRENT_FETCH_SUCCESS = 'USER/CURRENT/FETCH_SUCCESS';
export const USER_CURRENT_FETCH_FAILURE = 'USER/CURRENT/FETCH_FAILURE';

const initialState = {
  logged: {},
};

export const fetchCurrentUser = () => ({
  type: USER_CURRENT_FETCH,
  payload: {},
});

export const userReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case USER_CURRENT_FETCH_SUCCESS: {
      return { ...state, logged: { ...payload } };
    }
    case USER_CURRENT_FETCH_FAILURE: {
      console.error(USER_CURRENT_FETCH_FAILURE);
      return state;
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/user.reducer.js